/** The backend only takes bare semver, so a single leading "v" is dropped. */
export const stripVersionPrefix = (version: string) =>
  version.trim().replace(/^v/, "");

const SEMVER =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*)?(?:\+[0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*)?$/;

export const isVersion = (version: string) => SEMVER.test(version);
